import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ControlsModule } from "src/app/controls/controls.module";
import { SharedModule } from "src/app/shared/shared.module";
import { CourseViewComponent } from "./course-view.component";
import { TranslateModule } from "@ngx-translate/core";
import { CreateLearnsetComponent } from "./create-learnset/create-learnset.component";
import { EditCourseModule } from "./edit-course/edit-course.module";
import { LearnsetsListComponent } from "src/app/shared/learnsets-list/learnsets-list.component";
import { TestWidgetComponent } from "./test-widget/test-widget.component";
import { NewTestWidgetComponent } from "./new-test-widget/new-test-widget.component";
import { CreateTestComponent } from "./create-test/create-test.component";
import { TabsButtonsComponent } from "src/app/shared/tabs-buttons/tabs-buttons.component";
import { CreateExamModule } from "../create-exam/create-exam.module";
import { ExamListComponent } from "./exam-list/exam-list.component";

@NgModule({
  declarations: [
    CourseViewComponent,
    CreateLearnsetComponent
  ],
  imports: [
    CommonModule,
    ControlsModule,
    SharedModule,
    TranslateModule,
    EditCourseModule,
    LearnsetsListComponent,
    TestWidgetComponent,
    NewTestWidgetComponent,
    CreateTestComponent,
    TabsButtonsComponent,
    CreateExamModule,
    ExamListComponent
],
  exports: [
    CourseViewComponent
  ]
})
export class CourseViewModule { }